module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/anniversary/page-key-words/bg.png"
    }
  }, [_c('img', {
    staticClass: "main-title ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/page-key-words/5.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips-c"
  }, [_vm._v(" 点此生成您下半年的科研关键词")]), _vm._v(" "), _c('img', {
    staticClass: "brand-area ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/page-key-words/button.png"
    },
    on: {
      "click": _vm.handleButtonClick
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22d502ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Anniversary/PageKeyWords/index.vue
// module id = 1567
// module chunks = 8